import React, { useEffect, useRef } from 'react';
import { Animated, StyleProp, ViewStyle } from 'react-native';

export type FadeInOwnProps = {
    children: React.ReactNode;
    disableFade?: boolean;
    style?: StyleProp<ViewStyle>;
    isIn?: boolean;
};

export type FadeInProps = FadeInOwnProps;

const FadeIn: React.FC<FadeInProps> = ({ children, disableFade, style, isIn }) => {
    const animationRef = useRef(new Animated.Value(0));
    useEffect(() => {
        if (isIn === undefined || isIn === true) {
            animationRef.current?.setValue(0);
            Animated.timing(animationRef.current, {
                toValue: 1,
                duration: 600,
                useNativeDriver: true,
            }).start();
        } else {
            Animated.timing(animationRef.current, {
                toValue: 0,
                duration: 600,
                useNativeDriver: true,
            }).start();
        }
    }, [isIn]);

    if (disableFade) return <>{children}</>;

    return (
        <Animated.View
            style={[
                style,
                {
                    opacity: animationRef.current,
                },
            ]}
        >
            {children}
        </Animated.View>
    );
};

export default React.memo(FadeIn);
